module.exports = __webpack_public_path__ + "img/brands-mulino-charta.jpg?dc4bccf5f9e9f1fd62a8f824b2217f58";